export const initKakao = () => {
  if (window.Kakao) {
    const kakao = window.Kakao;
    if (!kakao.isInitialized()) {
      kakao.init(process.env.APP_KAKAO_TOKEN);
    }
  }
};

export const shareKakao = async (linkUrl, title, description) => {
  const basicTitle = "인공지능 서비스 마켓 아이소";
  const basicDescription = "이미지, 데이터 분석 등 다양한 아이소 앱을 사용해보세요.";
  const image =
    "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/apps%2Fpreview%2Faiso_logo.jpg?alt=media&token=e6014be6-b135-4fdf-bac2-9e86295ffac5";

  const sendTitle = title ? title : basicTitle;
  const sendDescription = description ? description : basicDescription;

  /* sendDefault */
  await window.Kakao.Link.sendDefault({
    objectType: "feed",
    content: {
      title: sendTitle,
      description: sendDescription,
      imageUrl: image,
      imageWidth: 1500,
      imageHeight: 600,
      link: {
        mobileWebUrl: linkUrl,
        webUrl: linkUrl,
      },
    },
    buttons: [
      {
        title: "아이소로 이동하기",
        link: {
          mobileWebUrl: linkUrl,
          webUrl: linkUrl,
        },
      },
    ],
  });
};
